// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { BootstrapButton, BootstrapIcon, BootstrapImage } from '../../../dsl/front';
let AuthorInfoSidebar = class AuthorInfoSidebar extends Vue {
    close() {
        this.$emit('sidebar-close');
    }
    open(value) {
        this.$emit('sidebar-open');
    }
};
__decorate([
    Prop({ type: Object, required: true })
], AuthorInfoSidebar.prototype, "author", void 0);
AuthorInfoSidebar = __decorate([
    Component({
        name: 'AuthorInfoSidebar',
        components: {
            BootstrapImage,
            BootstrapIcon,
            BootstrapButton
        },
        template: `
    <div>
    <!-- Sidebar Overlay -->
    <div class="editorial-office-module__sidebar__overlay" @click="close"></div>
    <div class="editorial-office-module__sidebar">

      <div class="editorial-office-module__sidebar__close">
        <BootstrapButton @click="close">
          <BootstrapIcon size="large" name="close" />
        </BootstrapButton>
      </div>

      <div v-if="author" class="editorial-office-module__sidebar__content">
        <!-- Image -->
        <div class="editorial-office-module__sidebar__content__image">
          <BootstrapImage v-bind="author.avatar"/>
        </div>
        <!-- Author full name -->
        <div class="editorial-office-module__sidebar__content__full_name">
          <p>{{author.firstName}} {{author.lastName}}</p>
        </div>
        <!-- Author position -->
        <div v-if="author.position" class="editorial-office-module__sidebar__content__position">
          <span>{{author.position}}</span>
        </div>
        <!-- Author description -->
        <div v-if="author.description" class="editorial-office-module__sidebar__content__description">
          <p>{{author.description}}</p>
        </div>
      </div>

    </div>
    </div>`
    })
], AuthorInfoSidebar);
export { AuthorInfoSidebar };
